export const RETURN_TO_PARAM = 'returnTo';

export const getCurrentReturnTo = () => {
    if (typeof window === 'undefined' || !window.location) {
        return null;
    }

    // The OAuth initiate endpoints validate returnTo as an absolute http(s) URI on an
    // allow-listed domain, so a bare path is rejected with a 422 (ENG-2590).
    const { origin, pathname, search } = window.location;
    if (!origin || !pathname) {
        return null;
    }

    return `${origin}${pathname}${search || ''}`;
};

export const appendReturnTo = (url, returnTo) => {
    if (!url || !returnTo) {
        return url;
    }

    const separator = url.includes('?') ? '&' : '?';
    return `${url}${separator}${RETURN_TO_PARAM}=${encodeURIComponent(returnTo)}`;
};

export const withCurrentReturnTo = (url) => appendReturnTo(url, getCurrentReturnTo());
